import './base'
import { BlogForm } from 'orga_manage'
import { NewsletterLegalTerms, mountOnDataBehavior, mountOnId } from 'shared'
import { ProfilePictureUpload, ProjectSelectionPage } from '../fe_manage'
import { ThankYouMessageButton } from 'modules'

document.addEventListener('DOMContentLoaded', () => {
  mountOnId(ProjectSelectionPage, 'mount-page')
  mountOnDataBehavior(BlogForm, 'manage-blog-form')
  mountOnDataBehavior(NewsletterLegalTerms, 'newsletter-legal-terms')
  mountOnDataBehavior(ProfilePictureUpload, 'profile-picture-upload')
  mountOnDataBehavior(ThankYouMessageButton, 'thank-you-message-button')

  // Change default picture preview in registration form when category is changed
  const catagorySelection = document.getElementById('fundraising_event_category') as HTMLInputElement
  const defaultImage = document.getElementById('default-image') as HTMLElement
  catagorySelection?.addEventListener('change', (event: Event) => {
    const target = event.target as HTMLSelectElement
    const option = target.options[target.options.selectedIndex]
    const url = option?.dataset?.url as string
    defaultImage.setAttribute('src', url)
  })
})
